import { useRef, useEffect } from 'react';
import type { FC } from 'react';
import styled from 'styled-components';

import { registerIcon, defaultThemeProp } from '@pega/cosmos-react-core';
import type { RichTextEditorState } from '@pega/cosmos-react-rte';
import * as sendIcon from '@pega/cosmos-react-core/lib/components/Icon/icons/send.icon';
import * as paperClipIcon from '@pega/cosmos-react-core/lib/components/Icon/icons/paper-clip.icon';

import type { FeedReplyInputProps } from './Feed.types';
import FeedInputRegion from './FeedInputRegion';

registerIcon(sendIcon, paperClipIcon);

export const StyledReplyInputContainer = styled.div``;

StyledReplyInputContainer.defaultProps = defaultThemeProp;

const FeedReplyInput: FC<FeedReplyInputProps> = (props: FeedReplyInputProps) => {
  const {
    defaultValue,
    id,
    banners,
    progress,
    onRewriteClick,
    attachments,
    onFilesAdded,
    onSubmit,
    onSetInputRef,
    onUnmount,
    ...restProps
  } = props;
  const rteRef = useRef<RichTextEditorState>(null);

  useEffect(() => {
    onSetInputRef?.({ ref: rteRef });
  }, [rteRef]);

  return (
    <StyledReplyInputContainer {...restProps}>
      <FeedInputRegion
        defaultValue={defaultValue}
        variant='reply'
        id={id}
        banners={banners}
        progress={progress}
        onRewriteClick={onRewriteClick}
        attachments={attachments}
        onFilesAdded={onFilesAdded}
        onSubmit={onSubmit}
        rteRef={rteRef}
        onUnmount={onUnmount}
      />
    </StyledReplyInputContainer>
  );
};

export default FeedReplyInput;
